import Vue from 'vue'
import { getApiBasePath } from '@/constants'

export const getKpiFrontStatistic = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/kpi/kpiStatistic`, params)
  return response.data
}

export const getKpiBackStatistic = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/kpi/kpiStatisticV`, params)
  return response.data
}

export const getKpiCallLinStatistic = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/kpi/callLineTeamStatistic`, params)
  return response.data
}

export const getKpiStatisticNS = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/kpi/kpiStatisticNS`, params)
  return response.data
}

export const getTotalCommissionAmount = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/kpi/kpiStatisticOne`, params)
  return response.data
}

export const getRecentCommissionData = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/kpi/kpiRecentCommissionData`, params)
  return response.data
}
